export interface Role {
    id: string;
    name: string;
    description: string;
    permissions: string[];
    users: string[]; // IDs de usuarios asignados
    deleted?: boolean;
}

// Lista de permisos disponibles en el sistema
// Por ahora solo permisos de visualización (view), los de escritura se agregarán después
export const AVAILABLE_PERMISSIONS = [
    { key: 'view.users', label: 'Ver Usuarios' },
    { key: 'view.roles', label: 'Ver Roles' },
    { key: 'view.invoices', label: 'Ver Facturas' },
    { key: 'view.external_invoices', label: 'Ver Facturas Externas' },
    { key: 'view.pre_invoices', label: 'Ver Pre-facturas' },
    { key: 'view.orders', label: 'Ver Órdenes' },
    { key: 'view.external_documents', label: 'Ver Documentos Externos' },
    { key: 'view.ia_config', label: 'Ver Configuración de IA' },
    { key: 'view.statuses', label: 'Ver Catálogo de Estatus' },
    { key: 'view.logistic_operators', label: 'Ver Catálogo de Operadores Logísticos' },
    { key: 'view.invoice_dashboard', label: 'Ver Dashboard de Facturas' },
];
